export default __webpack_public_path__ + "static/media/bills-icon.5c707ee2.svg";